const manageAccountInitialValues = (usr) => ({
    Nome: usr.Nome,
    Sobrenome: usr.Sobrenome,
    Email: usr.Email,
    ConfirmarEmail: '',
    Senha: '',
    ConfirmarSenha: '',
});
export default manageAccountInitialValues;
